import { CampaignsTable } from '@/components/features/campaigns'

export const Campaigns = () => <CampaignsTable />
